var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 14V10C6 8.93913 6.42143 7.92172 7.17157 7.17157C7.92172 6.42143 8.93913 6 10 6H14",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34 6H38C39.0609 6 40.0783 6.42143 40.8284 7.17157C41.5786 7.92172 42 8.93913 42 10V14",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42 34V38C42 39.0609 41.5786 40.0783 40.8284 40.8284C40.0783 41.5786 39.0609 42 38 42H34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14 42H10C8.93913 42 7.92172 41.5786 7.17157 40.8284C6.42143 40.0783 6 39.0609 6 38V34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30 24C30 27.3137 27.3137 30 24 30C20.6863 30 18 27.3137 18 24C18 20.6863 20.6863 18 24 18C27.3137 18 30 20.6863 30 24Z",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32 32L28.2 28.2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAppointment);
export default __webpack_public_path__ + "static/media/search-appointment.8c62ae703b5d73edb84277359ede60fc.svg";
export { ForwardRef as ReactComponent };